"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CredentialToggle: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      fontSize: function fontSize(_ref) {
        var props = _ref.props;
        return props.isTextVisible ? 12 : 8;
      },
      width: function width(_ref2) {
        var props = _ref2.props;
        return props.width;
      },
      display: 'inline-block',
      paddingRight: 10
    }
  },
  Icon: {
    fontSize: 18
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map